<script setup lang="ts">
import type { ApiBlockItemModel } from '~/types/contentapi';

const props = defineProps<{ components: ApiBlockItemModel[] }>();

const transformComponentType = (type?: string) => {
  if (!type) {
    return 'div';
  }

  let converted = type.charAt(0).toUpperCase() + type.slice(1);

  if (converted.startsWith('Block')) {
    converted = converted.slice(5);
  }

  return 'Lazy' + converted;
};

const denyList = computed<string[]>(() =>
  props.components.reduce<string[]>((acc, component) => {
    const values = component?.settings?.properties?.denyListProductClassifications;
    if (Array.isArray(values)) {
      return [...acc, ...values];
    }
    return acc;
  }, [])
);
const { isComponentAllowed } = useComponentAccess(denyList.value);
</script>

<template>
  <template v-for="(component, i) in components">
    <component
      v-if="isComponentAllowed(component)"
      :is="transformComponentType(component?.content?.contentType)"
      :blockIndex="i"
      :settings="component.settings"
      v-bind="component.content"
    />
    <div
      class="hidden"
      :data-component-name="transformComponentType(component?.content?.contentType)"
      :data-component-exclusions="component?.settings?.properties?.denyListProductClassifications"
    ></div>
  </template>
</template>
